export const MyContentIcon = () => (
  <svg
    width="18"
    height="12"
    viewBox="0 0 18 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.7188 5.09375C17.9062 5.36458 18 5.66667 18 6V10.5C18 10.9167 17.8542 11.2708 17.5625 11.5625C17.2708 11.8542 16.9167 12 16.5 12H1.5C1.08333 12 0.729167 11.8542 0.4375 11.5625C0.145833 11.2708 0 10.9167 0 10.5V6C0 5.66667 0.09375 5.36458 0.28125 5.09375L3.5625 0.625C3.6875 0.458333 3.86458 0.3125 4.09375 0.1875C4.32292 0.0625 4.54167 0 4.75 0H13.25C13.4583 0 13.6771 0.0625 13.9062 0.1875C14.1354 0.3125 14.3125 0.458333 14.4375 0.625L17.7188 5.09375ZM4.375 1.21875L1.59375 5H5.875L6.875 7H11.125L12.125 5H16.4062L13.625 1.21875C13.5417 1.07292 13.4167 1 13.25 1H4.75C4.58333 1 4.45833 1.07292 4.375 1.21875ZM17 6.5C17 6.35417 16.9479 6.23958 16.8438 6.15625C16.7604 6.05208 16.6458 6 16.5 6H12.75L11.75 8H6.25L5.25 6H1.5C1.35417 6 1.22917 6.05208 1.125 6.15625C1.04167 6.23958 1 6.35417 1 6.5V10.5C1 10.6458 1.04167 10.7708 1.125 10.875C1.22917 10.9583 1.35417 11 1.5 11H16.5C16.6458 11 16.7604 10.9583 16.8438 10.875C16.9479 10.7708 17 10.6458 17 10.5V6.5Z"
      fill="black"
    />
  </svg>
);
